import { useStore } from '@nanostores/react';
import { useCallback } from 'react';
import { useGithubCreateRepoFlow } from './GithubCreateRepoFlow';
import { LegacyIconButton } from '~/components/ui/LegacyIconButton';
import * as Tooltip from '~/components/ui/Tooltip';
import { useGithubStore } from '~/lib/context/github';

export function ConnectToGithubButton() {
  const { dialog: githubCreateRepoDialog, open: createRepo } = useGithubCreateRepoFlow();
  const github = useGithubStore();
  const githubConnectedTo = useStore(github.connection);

  const handleGithubClick = useCallback(async () => {
    const connected = githubConnectedTo.account || (await github.connectToGithub());

    if (!connected) {
      return;
    }

    if (githubConnectedTo.repo) {
      github.changeDropdownVisibility(true);
    } else {
      createRepo();
    }
  }, [github, createRepo]);

  return (
    <>
      <Tooltip.Provider>
        <Tooltip.Root>
          <Tooltip.Trigger asChild>
            <LegacyIconButton className="relative w-8 h-8" size="sm" onClick={handleGithubClick}>
              <div className="i-bx:bxl-github size-6 text-bolt-elements-textPrimary" />
            </LegacyIconButton>
          </Tooltip.Trigger>
          <Tooltip.Content>Connect project to Github</Tooltip.Content>
        </Tooltip.Root>
      </Tooltip.Provider>
      {githubCreateRepoDialog}
    </>
  );
}
